@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">BOM — Import</div>
  </div>

  @if (state.loading) {
    Ładowanie…
  } @else if (!state.preview) {
    <!-- State 1: the file is the action — choosing one requests the preview at once -->
    <div class="import-card card">
      <div class="card-header">WYBÓR PLIKU</div>

      <div class="import-fields">
        <div class="field">
          <span class="field-label">Format</span>
          <button class="btn format-btn" type="button" #formatTrigger>{{ state.selectedFormat?.name ?? '—' }} ▾</button>
        </div>

        <div class="field">
          <span class="field-label">Plik</span>
          <input class="field-input" type="file" [accept]="accept(state)" [disabled]="state.previewing" (change)="onFilePicked($event)">
        </div>
      </div>

      <dropdown [searchFunc]="searchFormats" [searchFormatter]="formatFormat" [trigger]="formatTrigger"
        [minSearchLength]="0" [debounceMs]="0" header="FORMAT" (itemSelected)="onFormatSelected($event)"></dropdown>

      <div class="import-hint">Inventor: Zestawienie komponentów → Eksport, widok strukturalny, wszystkie poziomy. Oryginalny plik zostanie dołączony do produktu, a obraz wklejony pod tabelą — jako zdjęcie główne.</div>

      @if (state.previewing) {
        <div class="import-status">Wczytywanie…</div>
      }

      @if (state.error) {
        <div class="form-error">{{ state.error }}</div>
      }
    </div>
  } @else {
    <!-- State 2: what the import will create, as the API computed it; the only inputs are the product's name and number -->
    <div class="import-card preview-card card">
      <div class="card-header">PODGLĄD</div>

      <!-- the product's head: the sheet's picture at a size you can recognise, the file line and the fields beside it (0087) -->
      <div class="preview-head">
        @if (state.preview.picture; as picture) {
          <img class="preview-picture" [src]="picture.dataUrl" [alt]="pictureLabel(picture)" [title]="pictureLabel(picture)">
        }

        <div class="preview-head-text">
          <div class="preview-summary">
            <span class="preview-file-name">{{ state.file?.name }}</span>
            <span class="preview-counts">{{ summaryLine(state.preview) }}</span>
            <!-- said in words too: beside the picture the note says what it becomes -->
            @if (state.preview.picture; as picture) {
              <span class="preview-counts">· {{ pictureCaption(picture) }}</span>
            }
          </div>

          <div class="import-fields">
            <label class="field">
              <span class="field-label">Nazwa produktu</span>
              <input #nameInput class="field-input" type="text" [value]="state.rootName" (input)="onRootNameInput(nameInput.value)">
            </label>

            <label class="field field-part-number">
              <span class="field-label">Numer części</span>
              <input #partNumberInput class="field-input text-mono" type="text" [value]="state.rootPartNumber" spellcheck="false" autocomplete="off"
                (input)="onRootPartNumberInput(partNumberInput.value)">
            </label>
          </div>
        </div>
      </div>

      <!-- one box, three tabs: the tree as a table of every imported value, then its aggregate as LISTA and WG TYPU -->
      <div class="preview-box">
        <tree-summary leadingTab="DRZEWO" [items]="summaryItems(state.preview)" rootType="product">
          <div class="list-row list-row-header preview-row">
            <div class="list-cell">Numer</div>
            <div class="list-cell">Nazwa</div>
            <div class="list-cell">Opis</div>
            <div class="list-cell list-cell-right">Masa</div>
            <div class="list-cell list-cell-right">Ilość</div>
          </div>

          @for (row of rows(state.preview, state); track $index) {
            <div class="list-row preview-row">
              <div class="list-cell preview-row-part-number text-mono" [title]="row.partNumber ?? ''">{{ row.partNumber ?? '—' }}</div>
              <div class="list-cell preview-row-name" [class.preview-row-existing]="row.existingName" [style.padding-left.px]="row.depth * 18" [title]="row.name">
                {{ row.name }}
                @if (row.existingName) {
                  <span class="preview-row-catalog">istniejący → {{ row.existingName }}</span>
                }
              </div>
              <div class="list-cell preview-row-description" [title]="row.description ?? ''">{{ row.description ?? '—' }}</div>
              <div class="list-cell list-cell-right preview-row-mass text-mono">{{ formatMass(row.massKg) }}</div>
              <div class="list-cell list-cell-right preview-row-amount text-mono">{{ formatAmount(row.amount, row.unit) }}</div>
            </div>
          }
        </tree-summary>
      </div>

      @if (state.preview.warnings.length > 0) {
        <div class="preview-warnings">
          <div class="preview-warnings-title">Uwagi ({{ state.preview.warnings.length }})</div>
          @for (warning of state.preview.warnings; track $index) {
            <div class="preview-warning">{{ warning.message }}</div>
          }
        </div>
      }

      <div class="import-actions">
        <button class="btn" type="button" [disabled]="!canImport(state)" (click)="onImportClick()">{{ state.importing ? 'Importowanie…' : 'Importuj' }}</button>
        <button class="btn" type="button" [disabled]="state.importing" (click)="onCancelClick()">Anuluj</button>

        @if (state.error) {
          <span class="form-error">{{ state.error }}</span>
        }
      </div>
    </div>
  }
}
